(function () {
  function measureTarget() {
    return document.getElementById('SiteHeader');
  }

  function syncHeaderOffset() {
    var target = measureTarget();
    if (!target) return;

    var height = Math.ceil(target.getBoundingClientRect().height);
    if (!height) return;

    var value = height + 'px';
    document.documentElement.style.setProperty('--site-header-offset', value);
    document.documentElement.style.setProperty('--byob-shop-header-offset', value);
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(fn, wait);
    };
  }

  function throttle(fn, wait) {
    var last = 0;
    return function () {
      var now = Date.now();
      if (now - last >= wait) {
        last = now;
        fn();
      }
    };
  }

  function bind() {
    syncHeaderOffset();

    var debouncedSync = debounce(syncHeaderOffset, 50);
    var throttledSync = throttle(syncHeaderOffset, 20);

    window.addEventListener('resize', debouncedSync);
    window.addEventListener('scroll', throttledSync, { passive: true });

    var header = measureTarget();
    if (header && typeof MutationObserver !== 'undefined') {
      new MutationObserver(debouncedSync).observe(header, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (header && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(debouncedSync).observe(header);
    }

    window.setTimeout(syncHeaderOffset, 120);
    window.setTimeout(syncHeaderOffset, 450);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
